// temporary workaround to keep tests working in scroll-lock.test
import iOS from './isiOS';

export const isiOS = () => iOS();
